<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.questionnaire_recommend") }}
    </div>
    <v-row class="mt-2 ml-3">
      <v-card-text class="" style="font-size: 1rem !important">
        <span style="color: red;">*</span>{{ $vuetify.lang.t("$vuetify.ai_response.prerequisite_txt") }}
      </v-card-text>
      <v-card-text class="text-caption text--secondary ml-3" style="font-size: 0.85rem !important">
        1. {{ $vuetify.lang.t("$vuetify.ai_response.questionnaire_recommend_prerequisite_txt1") }}
      </v-card-text>
      <v-card-text class="text-caption text--secondary ml-3" style="font-size: 0.85rem !important">
        2. {{ $vuetify.lang.t("$vuetify.ai_response.questionnaire_recommend_prerequisite_txt2") }}
      </v-card-text>
    </v-row>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.set_input_field_txt") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="user_id" :label='$vuetify.lang.t("$vuetify.ai_response.user_id")' dense outlined :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.user_id')
            ),
          ]">
          </v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="member_id" :label='$vuetify.lang.t("$vuetify.ai_response.member_id")' dense outlined></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="recommend_count" :label='$vuetify.lang.t("$vuetify.ai_response.recommend_count")' dense outlined
                        :rules="searchSizeRules"></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="top_k" :label='$vuetify.lang.t("$vuetify.ai_response.top_keyword")' dense outlined :rules="searchSizeRules"></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-select v-model="is_keyword_enabled" :items="KeywordEnabledList" :label='$vuetify.lang.t("$vuetify.ai_response.keyword_enabled")' outlined dense
          >
          </v-select>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-autocomplete
            v-model="result_includes"
            :items="Object.keys(catalogItems[0]?.item)"
            dense
            hide-selected
            outlined
            small-chips
            multiple
            deletable-chips
            :hint='$vuetify.lang.t("$vuetify.ai_response.result_includes_hint")'
            :label='$vuetify.lang.t("$vuetify.gpt_history.gpt_history_result_includes")'
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="6" xs="12">
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-select
            v-model="questionnaire_id" 
            :items="questionnaires_list" 
            :label='$vuetify.lang.t("$vuetify.ai_response.select_questionnaire")'
            item-text="name" item-value="id" outlined dense
            :rules="[required($vuetify.lang.t('$vuetify.ai_response.questionnaire_id'))]"
          >
          </v-select>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn v-if="questionnaire_id != ''" class="mr-4 primary--text" outlined @click="surveyModal=true">
            {{ $vuetify.lang.t("$vuetify.ai_response.answer_survey_questions") }}
          </v-btn>
        </v-col>

        <!-- SURVEY MODAL -->
        <v-dialog v-model="surveyModal" max-width="80%">
          <template v-if="questionnaireDetailsLoading">
            <Loader class="mr-2 mt-6" />
          </template>
          <v-card v-else class="d-flex flex-column"
                  style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
            <v-container>
              <v-card-title style="margin-left: -14px;">
                {{ $vuetify.lang.t("$vuetify.ai_response.answer_survey_questions") }}
              </v-card-title>
              <v-divider></v-divider>
            </v-container>

            <v-container>
              <template v-if="questionnaire_id !== ''">
                <!-- <v-form @keydown.enter.prevent> -->
                <v-row v-for="(category, categoryKey) in questions" :key="categoryKey">
                  <v-col cols="12">
                    <h3 @click="collapsedCategories[categoryKey] = !collapsedCategories[categoryKey]" class="d-flex align-center" style="cursor: pointer;">
                      <v-icon small class="mr-2">
                        {{ collapsedCategories[categoryKey] ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
                      </v-icon>
                      {{ categoryKey.replace('_', ' ').toUpperCase() }}
                    </h3>
                  </v-col>
                  <template v-if="!collapsedCategories[categoryKey]">
                    <v-col v-for="(question, questionKey) in category" :key="questionKey" cols="12" md="8">
                      <v-card class="mb-4 pa-3">
                        <v-card-title style="margin-left: -15px;">{{ question.question }}</v-card-title>
                        <v-text-field
                          v-if="question.type === 'text'" 
                          v-model="answers[categoryKey][questionKey]"
                          :label="question.question" 
                          outlined
                          >
                        </v-text-field>
                        <v-radio-group 
                          v-if="question.type === 'radio'"
                          v-model="answers[categoryKey][questionKey]"
                          :name="questionKey"
                          column
                          >
                          <v-radio 
                            v-for="(optionText, optionKey) in question.options" 
                            :key="optionKey"
                            :label="optionText" :value="optionKey"
                            >
                          </v-radio>
                        </v-radio-group>
                        <div v-if="question.type === 'checkbox'">
                          <v-checkbox
                            v-for="(optionText, optionKey) in question.options"
                            :key="optionKey"
                            :label="optionText"
                            :value="optionKey"
                            v-model="answers[categoryKey][questionKey]"
                          ></v-checkbox>
                        </div>
                      </v-card>
                    </v-col>
                  </template>
                </v-row>
                <!-- </v-form> -->
              </template>
            </v-container>
            <v-divider></v-divider>
            <v-card-title>
              <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
                <v-btn color="primary" text @click="surveyModal = false">{{ $vuetify.lang.t("$vuetify.ai_response.close") }}</v-btn>
              </v-card-actions>
            </v-card-title>
          </v-card>
        </v-dialog>
        <v-btn class="float-right ml-2" color="primary" @click="getQuestionnaireRecommend" dark>
          {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
        </v-btn>
        <v-card-title>
        </v-card-title>
      </v-row>
    </v-form>
    <v-dialog v-model="openResponseModal" max-width="80%">
      <template v-if="responseLoading">
        <Loader class="mr-2 mt-6" />
      </template>
      <v-card 
        v-else 
        class="d-flex flex-column"
        style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;"
        >
        <v-container>
          <v-card-title style="margin-left: -14px;">
            {{ $vuetify.lang.t("$vuetify.ai_response.questionnaire_recommend_items") }}
          </v-card-title>
          <v-divider></v-divider>
        </v-container>

        <v-container>
          <v-row v-for="(items, type) in questionnaireRecommendations" :key="type">
            <v-col cols="12">
              <h3 style="margin-top: 10px; margin-left: 8px;">{{ type }}</h3>
            </v-col>
            <v-row class="ml-2">
              <v-col v-for="product in items" :key="product[mapper.item_id]" cols="12" md="3">
                <v-card class="product-card" @click="copyItemToClipBoard(product)" outlined>
                  <v-img :src="product[mapper.image_url]" :alt="product[mapper.title] && product[mapper.title].slice(0, 50) || 'Image Not Available'" height="100px">
                    <template #placeholder>
                      <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                        {{ 'Image Not Available' }}
                      </div>
                    </template>
                  </v-img>
                  <div class="card-content">
                    <p class="ml-4">{{ product[mapper.title] && product[mapper.title].slice(0, 50) || 'Untitled Product'}}</p>
                    <strong class="ml-4">¥ {{ product[mapper.price]  || 'Price Unknown'}}</strong>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-row>
          <v-row v-if="Object.keys(questionnaireRecommendations).length === 0">
            <v-col  class="d-flex align-items-center pa-0">
              <v-icon class="text-info mr-2">mdi-information</v-icon>
              <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false"> {{ $vuetify.lang.t("$vuetify.ai_response.close") }}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import {
  QUESTIONNAIRES_LIST,
  QUESTIONNAIRE_DETAILS,
  QUESTIONNAIRE_RECOMMEND,
  ADD_ALERT
} from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      recommend_count: 1,
      type: "",
      storage: "",
      search_size: 1,
      language: "en",
      top_k: 20,
      include_fields: [],
      questionnaireDetailsLoading: false,
      is_keyword_enabled: false,
      KeywordEnabledList: [
        { text: 'True', value: true },
        { text: 'False', value: false }
      ],
      questionnaires_list: [],
      questionnaire_id: "",
      questionnaire: {},
      textAnswer: "",
      questions: {},
      answers: {},
      questionnaireRecommendations: {},
      surveyModal: false,
      TYPE: ["individual", "group"],
      STORAGE: ["memory", "database"],
      searchSizeRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      result_includes: [],
      collapsedCategories: {},
    };
  },
  mounted() {
    this.getQuestionnaires()
  },

  watch: {
    questionnaire_id(newVal) {
      if (newVal) {
        this.getQuestionnaireDetails(newVal);
      }
    }
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
    mapped_mapper: function(){
      const keys = [
        "item_id",
        "title",
        "price",
        "image_url"
      ]
      const mapped_keys = []
      keys.forEach(key => {
        if(this.mapper[key])
          mapped_keys.push(this.mapper[key])
      })
      return mapped_keys

    }
  },
  methods: {
    ...mapActions("ai_response", [QUESTIONNAIRES_LIST, QUESTIONNAIRE_DETAILS, QUESTIONNAIRE_RECOMMEND]),
    ...mapActions("alert", [ADD_ALERT]),
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
        `alert/${ADD_ALERT}`, {
          message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
          color: "success",
        }, { root: true }
      );
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    getQuestionnaires(){
      this.QUESTIONNAIRES_LIST({
        project_id: this.selectedProject.id,
      }).then((res)=> {
        this.questionnaires_list = res.data.detail.response.questionnaries
      }).catch(err => {
        console.error("error", err)
      })
    },
    getQuestionnaireDetails() {
      this.questionnaireDetailsLoading = true
      this.QUESTIONNAIRE_DETAILS({
        project_id: this.selectedProject.id,
        questionnaire_id: this.questionnaire_id
      }).then((res)=> {
        this.questionnaire = res.data
        this.questions = res.data.questions
        this.collapsedCategories = Object.keys(this.questions).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {});
        this.surveyModal = true
        this.questionnaireDetailsLoading = false
        this.initializeAnswers();
      }).catch(err => {
        console.error("error", err)
      })
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    initializeAnswers() {
      Object.keys(this.questions).forEach(categoryKey => {
        this.answers[categoryKey] = {};

        Object.keys(this.questions[categoryKey]).forEach(questionKey => {
          const questionType = this.questions[categoryKey][questionKey].type;
          this.answers[categoryKey][questionKey] = questionType === 'checkbox' ? [] : null;
        });
      });
    },

    getQuestionnaireRecommend(){
      const valid = this.validateForm()
      if(!valid) return

      const keys = [
        "title",
        "price",
      ]
      const result_includes_clone = [...this.result_includes]
      keys.forEach(key => {
        if(!result_includes_clone.includes(this.mapper[key]) )
          result_includes_clone.push(this.mapper[key])
      })

      this.openResponseModal = true
      this.responseLoading = true
      this.QUESTIONNAIRE_RECOMMEND({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        questionnaire_id: this.questionnaire_id,
        result_includes: result_includes_clone,
        recommend_count: this.recommend_count,
        top_k: this.top_k,
        is_keyword_enabled: this.is_keyword_enabled,
        values: this.answers
      }).then(res=> {
        this.questionnaireRecommendations = res.data.detail.recommendations
        this.responseLoading = false
      }).catch(error => {
        console.error("error", error)
        if(error.status === 422){
          this.$store.dispatch(
            `alert/${ADD_ALERT}`, {
              message: JSON.stringify(error?.response?.data?.detail),
              color: "error",
            }, { root: true }
          );
        } else {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`, {
              message: error?.response?.data?.detail?.response,
              color: "error",
            }, { root: true }
          );
        }
        this.openResponseModal = false
      })
    },

  }
};
</script>

<style scoped>
.product-card {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.card-content {
  padding: 4px;
}

.card-content .v-card-title {
  margin-bottom: 0;
  font-size: 16px;
}

.card-content .v-card-subtitle {
  margin-bottom: 8px;
}
</style>
